<template>
  <v-item-group @update:modelValue="onSelected" v-model="selectedIndex">
    <v-row class="pa-0 ma-0">
      <v-col
        v-for="(type, index) in data.items"
        :key="type.id"
        cols="12"
        md="4"
        lg="4"
        sm="6"
      >
        <v-item v-slot="{ toggle }">
          <v-card
            :color="index === selectedIndex ? 'primary' : ''"
            class="d-flex align-start"
            height="300"
            @click="toggle"
          >
            <v-scroll-y-transition hide-on-leave leave-absolute>
              <div
                v-if="index === selectedIndex"
                :key="type.id"
                class="flex-grow-1 d-flex flex-column justify-center align-center white--text full-height"
              >
                <h3>
                  {{ type.name }}
                </h3>
                <v-icon class="mt-2" color="white"> mdi-check-circle </v-icon>
              </div>

              <div v-else :key="`info` + type.id" class="full-height">
                <v-card-title>
                  <v-icon color="primary" class="mr-4">
                    {{ type.icon }}
                  </v-icon>
                  {{ type.name }}
                </v-card-title>

                <v-card-text>
                  {{ type.description }}
                </v-card-text>
                <v-card-actions class="card-actions-bottom">
                  <v-btn
                    @click.prevent.stop="() => $emit('onDetails', type)"
                    text
                    border
                  >
                    <template #prepend>
                      <v-icon left>mdi-information</v-icon>
                    </template>

                    Read More
                  </v-btn>
                </v-card-actions>
              </div>
            </v-scroll-y-transition>
          </v-card>
        </v-item>
      </v-col>
    </v-row>
  </v-item-group>
</template>




<script>
import { InventoryAPIInstance } from "../../../api";

export default {
  components: {},
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["next", "onDetails", "update:modelValue"],
  data() {
    return {
      selectedIndex: null,
      data: {
        items: [],
        pagination: {
          page: 1,
          pageSize: 10,
        },
      },
    };
  },
  computed: {},
  watch: {
    value(newVal) {
      if (!newVal) {
        this.selectedIndex = null;
      }
    },
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      const { items, pagination } = await InventoryAPIInstance.Types.list(
        this.data.pagination
      );

      this.data.items = items;
      this.data.pagination = pagination;
    },
    onSelected(value) {
      this.selectedIndex = value;
      this.$emit("update:modelValue", this.data.items[value]);

      setTimeout(() => {
        this.$emit("next");
      }, 300);
    },
  },
};
</script>